const PAYMENT_METHOD_PREFIX = "PaymentMethod";

export const PAYMENT_METHOD_CLASSES = {
  image: `${PAYMENT_METHOD_PREFIX}-image`,
};
